import { StrapiDocument, TimeStampAttributes } from '@dh/types';

export type TopicParent = StrapiDocument & {
    title: string;
    description: string;
};

export interface Topic extends TimeStampAttributes, StrapiDocument {
    title: string;
    parent: TopicParent;
    isDoubledScored?: boolean;
}

export type FetchTopicsInternalResponse = {
    topics: Topic[];
    error?: Error;
};

export type TopicCluster = {
    parent: TopicParent;
    topics: Topic[];
    someSelected?: boolean;
    allSelected?: boolean;
};

export const computeTopicHierarchy = (topics: Topic[]) => {
    const topicCluster: TopicCluster[] = [];
    topics.forEach((topic) => {
        const item = topicCluster.find(
            (item) => item.parent.documentId === topic.parent.documentId
        );
        if (!item) {
            topicCluster.push({
                parent: topic.parent,
                topics: [topic]
            });
        } else {
            item.topics.push(topic);
        }
    });
    return topicCluster.sort((a, b) => a.parent.title.localeCompare(b.parent.title));
};
